import { apiAddress } from '../ApiPlatform';

export const API_SELECT_EMP_LIST = apiAddress + '/emp/select';
export const API_INSERT_EMP = apiAddress + '/emp/insert';
export const API_UPDATE_EMP = apiAddress + '/emp/update';
export const API_EMP_LOGIN = apiAddress + '/emp/login';
export const API_EMP_PW_UPDATE = apiAddress + 'emp/pwUpdate';
